import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogTitle, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'

import { ConfirmationDialogModal } from '@modules/Shared/ConfirmationDialogModal/ConfirmationDialogModal'

import { globalStore } from '../../store/globalStore'

export const DialogModal = () => {
  const dialogModal = globalStore((state) => state.dialogModal)
  const requestCloseDialog = globalStore((state) => state.requestCloseDialog)
  const confirmCloseDialog = globalStore((state) => state.confirmCloseDialog)
  const dismissCloseConfirmation = globalStore((state) => state.dismissCloseConfirmation)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const closeConfirmation = dialogModal.closeConfirmation

  return (
    <div>
      <Dialog
        onClose={() => {
          requestCloseDialog()
        }}
        aria-labelledby="customized-dialog-title"
        open={dialogModal.open}
        fullScreen={fullScreen}
        fullWidth={true}
        PaperProps={{ sx: { maxWidth: dialogModal.maxWidth } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" fontWeight="regular">
              {dialogModal.titleDialog}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                requestCloseDialog()
              }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        {dialogModal.content}
      </Dialog>
      <ConfirmationDialogModal
        openDialog={!!dialogModal.pendingCloseConfirmation}
        modalTitle={closeConfirmation?.title ?? ''}
        modalBody={closeConfirmation?.body ?? ''}
        onConfirm={() => {
          confirmCloseDialog()
        }}
        onDismiss={() => {
          dismissCloseConfirmation()
        }}
      />
    </div>
  )
}
